import { jsxs, jsx } from "react/jsx-runtime";
import { BlockQuote } from "@zillow/zrs-cms";
import PropTypes from "prop-types";
import "react";
import makeContentInteractive from "../../util/makeSpansInteractive.esm.js";
const Quote = ({
  attrs
}) => {
  const {
    content,
    citation
  } = attrs;
  const parsedContent = makeContentInteractive(content);
  return /* @__PURE__ */ jsxs(BlockQuote, { children: [
    /* @__PURE__ */ jsx(BlockQuote.Content, { children: parsedContent }),
    citation && /* @__PURE__ */ jsx(BlockQuote.Citation, { children: citation })
  ] });
};
Quote.propTypes = {
  attrs: PropTypes.shape({
    content: PropTypes.string,
    citation: PropTypes.string
  }).isRequired
};
export {
  Quote as default
};
